module.exports = __webpack_public_path__ + "img/counter-ico-4.5640049d.svg";